var map = {
	"./Improvements/improvements_01.webp": 5406,
	"./Improvements/improvements_02.webp": 2559,
	"./Improvements/improvements_03.webp": 1020,
	"./Improvements/improvements_04.webp": 237,
	"./Improvements/improvements_05.webp": 7218,
	"./Improvements/improvements_06.webp": 995,
	"./Improvements/improvements_07.webp": 7152,
	"./Improvements/improvements_08.webp": 2593,
	"./Improvements/improvements_09.webp": 2838,
	"./Improvements/improvements_10.webp": 5228,
	"./Improvements/improvements_11.webp": 6463,
	"./Improvements/improvements_12.webp": 3470,
	"./Improvements/improvements_13.webp": 9497,
	"./Improvements/improvements_14.webp": 9344,
	"./Improvements/improvements_15.webp": 5107,
	"./Improvements/improvements_16.webp": 7458,
	"./LogoFooter.webp": 281,
	"./LogoHeader.webp": 9939,
	"./Projects/acueducto/acueducto-001.jpg": 9207,
	"./Projects/acueducto/acueducto-002.jpg": 8280,
	"./Projects/acueducto/acueducto-003.jpg": 5893,
	"./Projects/acueducto/acueducto-004.jpg": 8558,
	"./Projects/acueducto/acueducto-005.jpg": 9867,
	"./Projects/acueducto/acueducto-006.jpg": 2892,
	"./Projects/alcantarillado/alcantarillado-001.jpg": 5203,
	"./Projects/alcantarillado/alcantarillado-002.jpg": 1508,
	"./Projects/caminatas/caminata-001.jpg": 3938,
	"./Projects/caminatas/caminata-002.jpg": 3837,
	"./Projects/caminatas/caminata-003.jpg": 2704,
	"./Projects/inspecciones/inspeccion-001.jpg": 6911,
	"./Projects/inspecciones/inspeccion-002.jpg": 3296,
	"./Projects/inspecciones/inspeccion-003.jpg": 4429,
	"./Projects/redes/red-001.jpg": 6759,
	"./Projects/redes/red-002.jpg": 7832,
	"./Projects/tanque-almacenamiento/tanque-001.jpg": 3766,
	"./Projects/tanque-almacenamiento/tanque-002.jpg": 1537,
	"./Projects/tanque-almacenamiento/tanque-003.jpg": 4164,
	"./Projects/tanque-almacenamiento/tanque-004.jpg": 4975,
	"./Projects/tanque-almacenamiento/tanque-005.jpg": 2306,
	"./Projects/tanque-almacenamiento/tanque-006.jpg": 1565,
	"./favicon.webp": 7391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8307;